import { Bar } from 'react-chartjs-2';
import {
  CategoryScale,
  Chart,
  ChartData,
  ChartOptions,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { DeepPartial } from './helpers';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import { merge } from 'lodash';
import { Spinner } from '@heroui/react';

dayjs.extend(localeData);

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export interface BarChartProps {
  title?: string;
  options?: DeepPartial<ChartOptions<'bar'>>;
  data?: ChartData<'bar'>;
  isLoading?: boolean;
}

export function BarChart({
  title,
  options: customOptions,
  data: customData,
  isLoading,
  ...props
}: BarChartProps) {
  const options: ChartOptions<'bar'> = merge(
    {
      backgroundColor: '#b4b1c2',
      color: 'black',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'right',
          display: false,
        },
        title: {
          font: {
            weight: 'bold',
            size: 24,
            family: 'P22Underground',
          },
          fullSize: true,
          padding: 16,
          display: !!title,
          text: title,
        },
      },
    },
    customOptions ?? {}
  ) as ChartOptions<'bar'>;
  const data = {
    ...(customData ?? {}),
    datasets: customData?.datasets ?? [],
  } as ChartData<'bar'>;

  return isLoading ? (
    <Spinner size="lg" />
  ) : (
    <Bar data={data} options={options} {...props} />
  );
}
